// Adds commas for the UI
export const formatWithCommas = (value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

// Removes commas for the Database/API
export const stripCommas = (value) => value.replace(/,/g, "");